import ACTION_TYPES from '../../constants/actionTypes';
import clone from 'lodash/clone';
import findIndex from 'lodash/findIndex';
import uniqBy from 'lodash/uniqBy';

export default {
  clients(state = [], action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLIENTS_SUCCESS:
        return uniqBy([...state, ...action.payload], 'id');
      case ACTION_TYPES.GET_CLIENT_SUCCESS:
        return uniqBy([...state, action.payload], 'id');
      case ACTION_TYPES.UPDATE_CLIENT_SUCCESS:
        const index = findIndex(state, { id: action.payload.id });
        const newState = clone(state);
        newState.splice(index, 1, action.payload);
        return newState;
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
      case ACTION_TYPES.CLEAR_CLIENTS_LIST:
        return [];
      default:
        return state;
    }
  },

  clientsStats(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLIENTS_STATS_SUCCESS:
        return action.payload;
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return {};
      default:
        return state;
    }
  },

  isFetchingClients(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_CLIENTS:
      case ACTION_TYPES.GET_CLIENT:
        return true;
      case ACTION_TYPES.GET_CLIENTS_SUCCESS:
      case ACTION_TYPES.GET_CLIENTS_FAILURE:
      case ACTION_TYPES.GET_CLIENT_SUCCESS:
      case ACTION_TYPES.GET_CLIENT_FAILURE:
        return false;
      default:
        return state;
    }
  },

  isUpdatingClient(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.CREATE_CLIENT:
      case ACTION_TYPES.UPDATE_CLIENT:
        return true;
      case ACTION_TYPES.CREATE_CLIENT_SUCCESS:
      case ACTION_TYPES.CREATE_CLIENT_FAILURE:
      case ACTION_TYPES.UPDATE_CLIENT_SUCCESS:
      case ACTION_TYPES.UPDATE_CLIENT_FAILURE:
        return false;
      default:
        return state;
    }
  },
};
